import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPincZoomOut = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.55 22C14.2666 22 14 21.9457 13.75 21.837C13.5 21.729 13.2833 21.5833 13.1 21.4L7.94998 16.25L9.34998 14.8C9.58331 14.5667 9.84598 14.3873 10.138 14.262C10.4293 14.1373 10.7333 14.1167 11.05 14.2L13 14.65V6.50001C13 5.80001 13.2416 5.20834 13.725 4.72501C14.2083 4.24167 14.8 4.00001 15.5 4.00001C16.2 4.00001 16.7916 4.24167 17.275 4.72501C17.7583 5.20834 18 5.80001 18 6.50001V10.8H18.65C18.7333 10.8 18.8083 10.8167 18.875 10.85C18.9416 10.8833 19.0166 10.9167 19.1 10.95L22.8 12.75C23.2 12.9333 23.496 13.229 23.688 13.637C23.8793 14.0457 23.9333 14.4667 23.85 14.9L22.95 20.35C22.8666 20.8333 22.6333 21.2293 22.25 21.538C21.8666 21.846 21.4333 22 20.95 22H14.55ZM14.55 20H20.95L21.9 14.55L17.75 12.5H16V6.50001C16 6.35001 15.9543 6.22901 15.863 6.13701C15.771 6.04567 15.65 6.00001 15.5 6.00001C15.35 6.00001 15.229 6.04567 15.137 6.13701C15.0456 6.22901 15 6.35001 15 6.50001V17.1L10.75 16.2L14.55 20Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.49792 9.75C1.49792 9.33579 1.83371 9 2.24792 9H5.24792C5.66214 9 5.99792 9.33579 5.99792 9.75V12.75C5.99792 13.1642 5.66214 13.5 5.24792 13.5C4.83371 13.5 4.49792 13.1642 4.49792 12.75V11.5607L2.27825 13.7803C1.98536 14.0732 1.51049 14.0732 1.21759 13.7803C0.924701 13.4874 0.924701 13.0126 1.21759 12.7197L3.43726 10.5H2.24792C1.83371 10.5 1.49792 10.1642 1.49792 9.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.5 7.25C11.5 7.66421 11.1642 8 10.75 8H7.75C7.33579 8 7 7.66421 7 7.25V4.25C7 3.83579 7.33579 3.5 7.75 3.5C8.16421 3.5 8.5 3.83579 8.5 4.25V5.43934L10.7197 3.21967C11.0126 2.92678 11.4874 2.92678 11.7803 3.21967C12.0732 3.51256 12.0732 3.98744 11.7803 4.28033L9.56066 6.5H10.75C11.1642 6.5 11.5 6.83579 11.5 7.25Z",
			fill: "currentColor"
		})
	]
});
export default SvgPincZoomOut;
